<template>
  <UApp
    :toaster="{
      position: 'top-center',
    }">
    <NuxtLoadingIndicator :color="colorMode.preference === 'light' ? 'blue' : 'cyan'" :throttle="100" />

    <AImpersonatingBanner v-if="isImpersonating" />
    <NuxtLayout>
      <NuxtPage />
      <ModalsContainer />
      <slot name="layout" />
    </NuxtLayout>
  </UApp>
</template>

<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal'

const { isImpersonating } = useImpersonate()
const colorMode = useColorMode() as any
const favicon = environment('production') ? 'favicon.png' : 'favicon_test.png'

useHead({
  link: [
    {
      href: `/images/${favicon}`,
      rel: 'icon',
      type: 'image/png',
    },
  ],
})
</script>

<style>
:root {
  --ui-foreground: 000;
}
</style>
